import { render, staticRenderFns } from "./courseware-view.vue?vue&type=template&id=c2ae15a6&"
import script from "./courseware-view.vue?vue&type=script&lang=js&"
export * from "./courseware-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports